/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Room_SubtitleInputs */

const en_admin_resources_room_subtitle = /** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting room, office, phone booth, event space`)
};

const de_admin_resources_room_subtitle = /** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meetingraum, Büro, Telefonbox, Event-Space`)
};

const es_admin_resources_room_subtitle = /** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala de reuniones, oficina, cabina acústica, espacio para eventos`)
};

const fr_admin_resources_room_subtitle = /** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle de réunion, bureau, cabine acoustique, espace événementiel`)
};

/** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */
const it_admin_resources_room_subtitle = en_admin_resources_room_subtitle;

/** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_resources_room_subtitle = en_admin_resources_room_subtitle;

/** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */
const pl_admin_resources_room_subtitle = en_admin_resources_room_subtitle;

/** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */
const hu_admin_resources_room_subtitle = en_admin_resources_room_subtitle;

/** @type {(inputs: Admin_Resources_Room_SubtitleInputs) => LocalizedString} */
const ro_admin_resources_room_subtitle = en_admin_resources_room_subtitle;

/**
* | output |
* | --- |
* | "Meeting room, office, phone booth, event space" |
*
* @param {Admin_Resources_Room_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_room_subtitle = /** @type {((inputs?: Admin_Resources_Room_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Room_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_room_subtitle(inputs)
	if (locale === "de") return de_admin_resources_room_subtitle(inputs)
	if (locale === "es") return es_admin_resources_room_subtitle(inputs)
	if (locale === "fr") return fr_admin_resources_room_subtitle(inputs)
	if (locale === "it") return it_admin_resources_room_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_room_subtitle(inputs)
	if (locale === "pl") return pl_admin_resources_room_subtitle(inputs)
	if (locale === "hu") return hu_admin_resources_room_subtitle(inputs)
	return ro_admin_resources_room_subtitle(inputs)
});
export { admin_resources_room_subtitle as "admin.resources.room_subtitle" }